import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentAnswersByIds, removeDefaultAnswers } from "../pages/helpers";
import {
  getSourceSystemIsCNP,
  getQuestionsByCategory,
  getSourceSystemIsBranchAppraisal,
  getAppraisalData
} from "../store/selectors";
import { appraisalSlice } from "../store/slices/Appraisal";
import { useNavigate } from "react-router-dom";
import { useSourceSystem } from "../hooks/useSourceSystem";
import {
  FactualQuestionsOrder,
  questionRoutingLabels
} from "../data/QuestionPresentation";
import { sendEvent } from "../helpers/analytics";

export default function InitialOfferCTA({
  promoActionNotRequired,
  isPartExchangeCustomer
}) {
  const isCnp = useSelector(getSourceSystemIsCNP);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const assumptionQuestions = useSelector(getQuestionsByCategory("Assumption"));
  const factualQuestions = useSelector(getQuestionsByCategory("Factual"));
  const assumptionIds = assumptionQuestions.map(
    (assumptionQuestion) => assumptionQuestion.id
  );
  const factualIds = factualQuestions.map(
    (assumptionQuestion) => assumptionQuestion.id
  );
  const isBranchAppraisal = useSelector(getSourceSystemIsBranchAppraisal);
  const firstFactualQuestion = FactualQuestionsOrder[0];
  const { questionsAndAnswers } = useSelector(getAppraisalData);
  const {
    sourceSystem: { analyticSearchParam }
  } = useSourceSystem();

  return (
    <>
      <>
        {promoActionNotRequired && (
          <p className="ch-mt--3 ch-text--center  ch-color--grey-6">
            For an accurate valuation, take <strong>three minutes</strong> to
            tell us about your car
          </p>
        )}
      </>
      {!isBranchAppraisal && (
        <button
          className="ch-btn ch-btn--primary ch-btn--block"
          onClick={() => {
            if (analyticSearchParam) {
              sendEvent("event", "interaction", {
                label: "Full valuation"
              });
            }
            const currentAssumptionAnswers = getCurrentAnswersByIds(
              questionsAndAnswers,
              assumptionIds
            );
            const currentFactualAnswers = getCurrentAnswersByIds(
              questionsAndAnswers,
              factualIds
            );
            const updatedFactualAnswersOnly = removeDefaultAnswers(
              currentFactualAnswers,
              factualQuestions
            );
            dispatch(
              appraisalSlice.actions.removeDefaultFactualAndConditionAnswers({
                ...currentAssumptionAnswers,
                ...updatedFactualAnswersOnly
              })
            );
            if (isPartExchangeCustomer) {
              dispatch(
                appraisalSlice.actions.setQuickValuationPartExchange(false)
              );
            }
            if (isCnp) {
              navigate(`/branch/condition`);
            } else {
              navigate(`/${questionRoutingLabels[firstFactualQuestion]}`);
            }
          }}
        >
          Complete a full valuation
        </button>
      )}
    </>
  );
}
